import React from "react"
import Base from "./Base"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps} from "../../Redux/Selectors"
import { Form, Alert } from "antd"
import { withBreakpoints } from "react-breakpoints"
import { withRouter } from 'react-router-dom'
import '../../Styles/UserPanel/Invoice.css'
import PaymentForm from "../../Components/Payments/PaymentForm"

class UpgradePlan extends React.Component {


    render() {

        return (
            <Base
                title="Elegí tu Plan"
                selected="mejorar-plan"
            >
                {/*{!this.props.login.user_data.subscripted &&*/}
                {/*<Alert*/}
                {/*    message='Ya estás suscripto'*/}
                {/*    description={<>Se te cobrará automáticamente en unos días. No es necesario que realices ningun pago. </>}*/}
                {/*    type="warning"*/}
                {/*    showIcon*/}
                {/*    style={{marginBottom: '10px'}}*/}
                {/*/>}*/}
                <PaymentForm
                stepsUser={false}/>
            </Base>
        );
    }
}

const Plans = Form.create({ nombre: 'plans' })(withBreakpoints(UpgradePlan));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Plans));
